import { createAsyncThunk } from "@reduxjs/toolkit";
import { Attributes, DefaultApi } from "@vviinn/user-managment-client-ts";
import { ApiRequest, serializeModel } from "../../../api";
import { CampaignRequest, CampaignTypeRequest } from "./types";

export const fetchCampaigns = createAsyncThunk(
  "campaigns/fetch",
  async ({ api, value }: ApiRequest<CampaignRequest>) => {
    const { companyId, siteId } = value;
    if (companyId === undefined) {
      return [];
    }
    const response = await api.getSiteCampaigns(companyId, siteId);
    const data = response.value;
    return data.map(serializeModel);
  },
);

export const fetchCampaignsAttributes = createAsyncThunk(
  "campaigns/attributes/fetch",
  async ({ api, value }: ApiRequest<CampaignRequest>) => {
    const { companyId, siteId } = value;
    if (companyId === undefined) {
      return [];
    }
    const response = await api.getPredictableCampaignAttributes(
      companyId,
      siteId,
    );
    const data = response.value;
    return serializeModel<Attributes>(data);
  },
);

export const fetchCampaignTypeExist = createAsyncThunk(
  "campaigns/type/exist",
  async ({ api, value }: ApiRequest<CampaignTypeRequest>) => {
    const { companyId, siteId, campaignType } = value;
    if (companyId === undefined) {
      return false;
    }
    await api.inquiryDefaultActiveCampaignsExistenceByType(
      companyId,
      siteId,
      campaignType,
    );
    return campaignType;
  },
);

export const fetchCampaignsFilters = createAsyncThunk(
  "filters",
  async (api: DefaultApi) => {
    const response = await api.getFilters();
    return serializeModel(response.value);
  },
);
